<template>
  <div class="b-movie-card" :class="[activeClass, videoClass]">
    <div
      class="b-movie-card__wrapper"
      :style="{ ...elementsShowOptions.posterCardDimensions }"
      :class="selectedMovie">
      <div class="b-movie-card__wrapper__img">
        <img v-if="!hasVideoId || !playVideo" :src="imgPoster" :alt="title" />
        <YouTubeVideo
          v-if="showYoutubePlayer"
          youtube-scale="scale(1.25) translateX(0)"
          :youtube-id="videoId"
          :autoplay="1"
          :video-placeholder="imgPoster"
          :muted="true"
          :loop="true"
          @on-player-state-change="onPlayerStateChange" />
      </div>
      <component
        :is="isBookingFlow ? 'div' : 'a'"
        :href="isBookingFlow ? null : computedMovieUrl"
        class="b-movie-card__wrapper__elements"
        :title="title">
        <ScreenTypes
          container-class="e-rooms--green"
          :sphera="sphera"
          :dolby="dolby"
          :three-dimensions="threeDimensions"
          :imax="imax"
          :imax3d="imax3D" />

        <div
          v-if="elementsShowOptions.showMoreCta"
          class="b-movie-card__btn-area">
          <div
            v-if="elementsShowOptions.showPremier && dictionary.premier && due"
            class="e-label e-label--bg e-label--playing">
            <span>{{ dictionary.premier }}</span>
            {{ due }}
          </div>

          <button
            v-if="elementsShowOptions.showTrailerCta && videoId"
            type="button"
            class="b-movie-card__trailer-btn btn-secondary btn-secondary--play"
            @click.stop.prevent="playTrailerInFullMode(videoId)">
            {{ dictionary.trailer }}
          </button>
          <div class="b-movie-card__wrapper__cta"></div>
        </div>
      </component>
    </div>

    <div class="b-movie-card__attr">
      <div v-if="transl" class="e-label e-label--translated">
        {{ dictionary.translatable }}
      </div>
      <div v-if="onlyMembers" class="e-label e-label--members">
        <span>{{ dictionary.onlyMembers }}</span>
      </div>
      <div class="b-movie-card__title">{{ title }}</div>
      <div v-if="subtitle" class="b-movie-card__subtitle">{{ subtitle }}</div>
      <div
        v-if="elementsShowOptions.showDesc"
        class="b-movie-card__subtitle"
        v-html="description"></div>
    </div>

    <div class="b-movie-attr">
      <div v-if="pg" class="e-k">{{ pg }}</div>
      <div
        v-if="elementsShowOptions.showGenres && genres.length && genres[0]"
        class="movie-attr--movie">
        <span>
          <em v-for="genre in genres" :key="genre">
            {{ genre }}
          </em>
        </span>
      </div>
      <div
        v-if="elementsShowOptions.showDuration && duration"
        class="movie-attr--time">
        <span>{{ duration }}</span>
      </div>
    </div>

    <div
      v-if="elementsShowOptions.showBookingCta"
      class="b-movie-card__btn-area">
      <button type="button" class="btn-primary" @click="openBooking">
        <span>{{ dictionary.bookTickets }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import constants from '../../lib/constants'
import YouTubeVideo from './YouTubeVideo.vue'
import bookingRedirect from '../../lib/bookingRedirect'
import ScreenTypes from '../components/Shared/ScreenTypes.vue'
const { redirectIntoBooking } = bookingRedirect()

export default {
  components: {
    YouTubeVideo,
    ScreenTypes,
  },
  props: {
    isBookingFlow: { default: false, type: Boolean },
    videoId: { default: '', type: String },
    progress: { default: 0, type: Number },
    active: { default: false, type: Boolean },
    title: { default: '', type: String, required: true },
    subtitle: { default: '', type: String },
    image: { default: '', type: String, required: true },
    description: { default: '', type: String },
    pg: { default: '', type: String, required: true },
    duration: { default: 0, type: Number, required: true },
    dolby: { default: false, type: Boolean },
    sphera: { default: false, type: Boolean },
    threeDimensions: { default: false, type: Boolean },
    imax: { default: false, type: Boolean },
    imax3D: { default: false, type: Boolean },
    movieUrl: { default: '', type: String },
    due: { default: '', type: String },
    transl: { default: false, type: Boolean },
    onlyMembers: { default: false, type: Boolean },
    genres: {
      default() {
        return []
      },
      type: Array,
    },
    dictionary: {
      default() {
        return { message: 'Object data' }
      },
      type: Object,
    },
    play: { default: false, type: Boolean, required: true },
    elementsShowOptions: {
      default() {
        return {
          showPremier: true,
          showTrailerCta: true,
          showBookingCta: true,
          showDuration: true,
          showGenres: true,
          showDesc: true,
          showMoreCta: true,
          showOnlyMembers: true,
          posterCardDimensions: {
            // minHeight: '490px',
            // minWidth: '356px',
          },
        }
      },
      type: Object,
    },
    selected: {
      default: false,
      type: Boolean,
    },
    movieId: { default: '', type: String },
    cinemaId: { default: '', type: String },
  },
  emits: ['playerStateChange', 'playTrailerInFullMode'],
  computed: {
    activeClass() {
      return this.active ? 'b-movie-card--active' : ''
    },
    hasVideoId() {
      return this.videoId
    },
    playVideo() {
      return this.play
    },
    showYoutubePlayer() {
      return this.playVideo && this.hasVideoId
    },
    selectedMovie() {
      return this.selected ? 'b-movie-card__selected-movie' : ''
    },
    videoClass() {
      return this.showYoutubePlayer ? 'b-movie-card--video' : ''
    },
    imgPoster() {
      return this.image ? this.image : constants.noImg
    },

    computedMovieUrl() {
      if (this.cinemaId && this.cinemaId !== 'All') {
        return `${this.movieUrl}?cinemaId=${this.cinemaId}`
      }
      return this.movieUrl
    },
  },
  methods: {
    openBooking() {
      const { baseUrl } = this.configuration

      if (this.cinemaId) {
        redirectIntoBooking(baseUrl, this.movieId, this.cinemaId)
      } else {
        redirectIntoBooking(baseUrl, this.movieId)
      }
    },
    playTrailerInFullMode(videoId) {
      this.$emit('playTrailerInFullMode', videoId)
    },
    onPlayerStateChange(ev) {
      this.$emit('playerStateChange', ev, this.videoId)
    },
  },
}
</script>
